import { jsx as _jsx } from "react/jsx-runtime";
import { Accordion, AccordionDetails, AccordionSummary, styled } from "@mui/material";
import { AccordionProvider, useAccordion } from "./context";
import { useEffect } from "react";
const DefaultAccordion = styled((props)=>{
    const { handleAccordionChange , openId  } = useAccordion();
    const { id , ...rest } = props;
    if (openId === undefined) return;
    useEffect(()=>{
        if (!openId && props.defaultExpandedId) handleAccordionChange(props.defaultExpandedId);
    }, []);
    return /*#__PURE__*/ _jsx(Accordion, {
        ...rest,
        expanded: openId === id || props.expanded ? true : false,
        onChange: (event, expanded)=>{
            if (expanded) handleAccordionChange(id);
            else handleAccordionChange(false);
        }
    });
})((param)=>{
    let { theme  } = param;
    return {
        padding: 0,
        boxShadow: "none",
        ":before": {
            backgroundColor: "transparent"
        }
    };
});
const Summary = styled((props)=>{
    const { defaultIcon  } = useAccordion();
    return /*#__PURE__*/ _jsx(AccordionSummary, {
        expandIcon: props.expandIcon || defaultIcon,
        ...props
    });
})((param)=>{
    let { theme  } = param;
    return {
        borderBottom: 0,
        padding: 0,
        margin: 0,
        "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
            transform: "rotate(180deg)"
        },
        " .MuiAccordionSummary-root.Mui-expanded": {
            minHeight: "fit-content"
        },
        "& .MuiAccordionSummary-content": {
            flexGrow: "inherit",
            margin: 0
        },
        "& .MuiAccordionSummary-content.Mui-expanded": {
            margin: 0
        }
    };
});
const Details = styled(AccordionDetails)((param)=>{
    let { theme  } = param;
    return {
        padding: 0
    };
});
export const Accordions = (param)=>{
    let { children , defaultExpandIcon , ...props } = param;
    return /*#__PURE__*/ _jsx(DefaultAccordion, {
        ...props,
        children: children
    });
};
// 아코디언이 여러개일 경우, 여러개의 아코디언을 관리하기 위한 컨테이너
export const AccordionsContainer = (param)=>{
    let { children , defaultExpandIcon , ...props } = param;
    return /*#__PURE__*/ _jsx(AccordionProvider, {
        defaultIcon: defaultExpandIcon,
        ...props,
        children: children
    });
};
Accordions.Summary = Summary;
Accordions.Details = Details;
